import { Box, DirectionProvider, MantineProvider, useDirection } from '@mantine/core';
import { Notifications } from '@mantine/notifications';
import { PropsWithChildren, useEffect } from 'react';

import { DirectionWrapper } from '@hendrx/shared/components/app/DirectionWrapper';
import { resolver } from 'shared/utils/ui/resolver';
import { useThemeOverride } from 'shared/utils/ui/theme';
import { useUiLanguage } from 'shared/utils/useUiLanguage';

export default function UIProvider({ children }: PropsWithChildren) {
  const { uiDirection } = useUiLanguage();
  const themeOverride = useThemeOverride();

  return (
    <DirectionProvider detectDirection={false}>
      <MantineProvider theme={themeOverride} cssVariablesResolver={resolver}>
        <InitalizeDirection>
          <Box data-testid="page">
            <DirectionWrapper direction={uiDirection}>{children}</DirectionWrapper>
          </Box>
          <Notifications dir={uiDirection} />
        </InitalizeDirection>
      </MantineProvider>
    </DirectionProvider>
  );
}

const InitalizeDirection = (props: PropsWithChildren) => {
  const { children } = props;
  const { uiDirection } = useUiLanguage();
  const { setDirection } = useDirection();

  useEffect(() => {
    setDirection(uiDirection);
  }, [setDirection, uiDirection]);

  return children;
};
